//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/TemplateTestManager.js";
let d=[[],[[["testName","version","errorCodes","partName","convertToLDV","onlySectionViews"],"RunViewUpdate",{},6,0],[["testName","version","errorCodes","partName","conversionType","viewFilter"],"RunViewUpdate1",{},6,0],[["testName","version","errorCodes","partName","conversionType","viewFilter","performAngularTest"],"RunSoakTest",{},7,0],[["testName","version","errorCodes","partName","convertToLDV","onlySectionViews","performAngularTest"],"RunSoakTest1",{},7,0]],[]];
SPLM.DraftTemplateTestManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.DraftTemplateTestManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DraftTemplateTestManager.ViewConversionType = Object.freeze({
    "None" : "None", "Exact" : "Exact", "Lightweight" : "Lightweight"});

SPLM.DraftTemplateTestManager.ViewFilter = Object.freeze({
    "None" : "None", "Section" : "Section"});

export default SPLM;